export const RECENT_ASSESSMENT_DATA = {
  heading: "Recent Assessments",
  data: [
    {
      name: "ReactJS Assessment SDE 1",
      status: "InProgress",
      date: "2 Apr 2024",
      totalAssigned: 210,
      totalAttended: 10,
      totalShortlisted: 0,
    },
    {
      name: "ReactJS Assessment SDE 1",
      status: "InProgress",
      date: "2 Apr 2024",
      totalAssigned: 210,
      totalAttended: 0,
      totalShortlisted: 0,
    },
    {
      name: "ReactJS Assessment SDE 1",
      status: "Incomplete",
      date: "2 Apr 2024",
      totalAssigned: null,
      totalAttended: 0,
      totalShortlisted: 0,
    },
    {
      name: "ReactJS Assessment SDE 1",
      status: "Published",
      date: "2 Apr 2024",
      totalAssigned: 210,
      totalAttended: 0,
      totalShortlisted: 20,
    },
    {
      name: "ReactJS Assessment SDE 1",
      status: "Published",
      date: "2 Apr 2024",
      totalAssigned: 210,
      totalAttended: 0,
      totalShortlisted: 20,
    },
  ],
};

export const HIRING_FUNNEL_DATA = {
  title: "Hiring Funnel",
  chart: [
    {
      key: "candidatesAssigned",
      value: 66,
      color: "rgba(60, 89, 179, 1)",
      height: 3.6,
      label: "Candidates assigned",
    },
    {
      key: "candidatesAppeared",
      value: 66,
      color: "rgba(77, 128, 244, 1)",
      height: 2.8,
      label: "Candidates appeared",
    },
    {
      key: "examCompleted",
      value: 66,
      color: "rgba(255, 229, 166, 1)",
      height: 2.6,
      label: "Exam Completed",
    },
    {
      key: "candidatesShortlisted",
      value: 66,
      color: "rgba(241, 194, 77, 1)",
      height: 1.4,
      label: "Candidates Shortlisted",
    },
  ],
  description: (
    <>
      Your conversion rates are <b>10%</b> and your exam completion rates are{" "}
      <b>20%</b>
    </>
  ),
};

export const ASSESSMENT_PERFORMANCE_DATA = {
  heading: "Assessment Performance",
  chart: [
    {
      color1: "rgba(241, 194, 77, 1)",
      color2: "rgba(255, 229, 166, 1)",
      height1: "2.8",
      height2: "2.4",
      label: "Average Time Taken",
    },
    {
      color1: "rgba(241, 194, 77, 1)",
      color2: "rgba(255, 229, 166, 1)",
      height1: "3.5",
      height2: "3.1",
      label: "Average Score",
    },
    {
      color1: "rgba(241, 194, 77, 1)",
      color2: "rgba(255, 229, 166, 1)",
      height1: "2.7",
      height2: "2.9",
      label: "Pass Rates",
    },
  ],
};
